import { userRepository } from '@/infrastructure/repositories';
import {
  UserListResponse,
  UserDetailResponse,
  UserFilters,
} from '@/domain/entities';
import { HttpError } from '@/domain/entities/ApiError';

export class UserService {
  async getUsers(filters: UserFilters = {}): Promise<UserListResponse> {
    try {
      return await userRepository.getAll(filters);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось загрузить список пользователей');
    }
  }

  async getUser(id: string, recentLimit?: number): Promise<UserDetailResponse> {
    try {
      return await userRepository.getById(id, recentLimit);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось загрузить данные пользователя');
    }
  }

  async deleteUser(id: string): Promise<void> {
    try {
      await userRepository.delete(id);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось удалить пользователя');
    }
  }
}

export const userService = new UserService();

